/**
 * @desc 保存或编辑
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelWarehouseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelWarehouse/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
